var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("header", { staticClass: "mb-5" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "dinlineb valign-middle ml-3" }, [
        _c("h2", { staticClass: "m-0 mb-2" }, [
          _vm._v(_vm._s(_vm.$l10n.__("Rapprochement bancaire")))
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "semibold flex-level",
            attrs: { href: "/?_f=bankreconciliation_transactions" }
          },
          [
            _c("i", { staticClass: "icon-arrow-back mr-1" }),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.$l10n.__("Retour")))])
          ]
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "step-container m-auto" },
      [
        _c("router-view", {
          attrs: {
            idImport: _vm.idImport,
            csv: _vm.csv,
            nextStep: _vm.nextStep,
            previousStep: _vm.previousStep
          },
          on: {
            "update-csv": _vm.updateCSV,
            "update-import-id": _vm.updateIdImport,
            next: _vm.goToNextStep,
            previous: _vm.goToPreviousStep
          },
          model: {
            value: _vm.form,
            callback: function($$v) {
              _vm.form = $$v
            },
            expression: "form"
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "round-64 relative dinlineb valign-middle primary-50-bkg"
      },
      [
        _c("i", {
          staticClass: "fab fa-sellsy absolute-center white",
          staticStyle: { "font-size": "32px" }
        })
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }